import React from "react";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import RecordVoiceOver from "@material-ui/icons/RecordVoiceOver";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import { fileTypes } from "../../../variables/data";
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...customSelectStyle,
  ...sweetAlertStyle
};

class UploadStep1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      show: false,
      redirect_url: "",
      description: "",
      file: null,
      update_id: 0,
      ad_id: "",
      image_ref: "",
      type: "agent"
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleWrongImage = this.handleWrongImage.bind(this);
    this.titleAndTextAlert = this.titleAndTextAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  componentDidMount() {
    const { update, adData } = this.props;
    if (update) {
      this.setState({
        redirect_url: adData.data.redirect_url,
        description: adData.data.description,
        ad_id: adData.id,
        update_id: adData.data.update_id,
        image_ref: adData.data.image_ref,
        type: adData.data.type
      });
    }
  }
  sendState() {
    return this.state;
  }
  handleImageChange(file) {
    this.setState({
      file: file
    });
  }
  change(event, stateName) {
    this.setState({ [stateName]: event.target.value });
  }
  handleTypeChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    //this.props.handleDateChange(event.target.value);
  };

  handleWrongImage = (reqWidth, reqHeight) => {
    this.titleAndTextAlert(
      "Wrong Image Dimensions",
      "Select " + reqWidth + " x " + reqHeight + " image"
    );
  };

  isValidated() {
    if (this.props.update === false && this.state.file === null) {
      return false;
    }
    return true;
  }

  titleAndTextAlert(title, detail) {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={title}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.info
          }
        >
          {detail}
        </SweetAlert>
      )
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const {
      classes,
      adData,
      update,
      ad_space,
      requiredWidth,
      requiredHeight
    } = this.props;
    return (
      <div>
        {this.state.alert}
        <GridContainer justify="center">
          <GridItem xs={12} sm={4}>
            <div>
              <ImageUpload
                update={update}
                adData={adData}
                ad_space={ad_space}
                handleImageChange={this.handleImageChange}
                handleWrongImage={this.handleWrongImage}
                requiredWidth={requiredWidth}
                requiredHeight={requiredHeight}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6}>
            <CustomInput
              success={this.state.firstnameState === "success"}
              error={this.state.firstnameState === "error"}
              labelText={
                <span>
                  Description <small>(required)</small>
                </span>
              }
              id="descritpion"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                //value: (update) ? adData.data.description : "",
                defaultValue: update ? adData.data.description : "",
                onChange: event => this.change(event, "description"),
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <Face className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                )
              }}
            />
            <CustomInput
              success={this.state.lastnameState === "success"}
              error={this.state.lastnameState === "error"}
              labelText={
                <span>
                  Redirect Url <small>(required)</small>
                </span>
              }
              id="redirect_uri"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.change(event, "redirect_url"),
                defaultValue: update ? adData.data.redirect_url : "",
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.inputAdornment}
                  >
                    <RecordVoiceOver className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                )
              }}
            />
            {ad_space === "4" || ad_space === "5" ? (
              <FormControl fullWidth className={classes.selectFormControl}>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={this.state.type}
                  onChange={this.handleTypeChange}
                  inputProps={{
                    name: "type",
                    id: "type"
                  }}
                >
                  {fileTypes.map((file, key) => {
                    return (
                      <MenuItem
                        key={key}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected
                        }}
                        value={file.value}
                      >
                        {file.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : null}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(style)(UploadStep1);



// WEBPACK FOOTER //
// ./src/views/Forms/WizardSteps/UploadStep1.jsx